import { GrupoEnum } from "@shared/enums";
import { Nilable } from "@shared/utils";
import { ClienteDTO } from "./Cliente.DTO";

export interface IAuthDTO {
    email: Nilable<string>;
    password: Nilable<string>;
    token: string;
    group: GrupoEnum;
    customer_id: number;
}

export class AuthDTO {
    public email = "";
    public password = "";
    public token = "";
    public grupo = GrupoEnum.CUSTOMER;
    public cliente = new ClienteDTO();

    constructor(json: Nilable<Partial<IAuthDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IAuthDTO>) {
        if (json.email != null) {
            this.email = json.email;
        }
        if (json.password != null) {
            this.password = json.password;
        }
        if (json.token != null) {
            this.token = json.token;
        }
        if (json.group != null) {
            this.grupo = json.group;
        }
        if (json.customer_id != null) {
            this.cliente = new ClienteDTO({ id: json.customer_id });
        }
    }

    public toJSON(): IAuthDTO {
        return {
            email: this.email,
            password: this.password,
            token: this.token,
            group: this.grupo,
            customer_id: this.cliente.id
        };
    }
}
